import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px 18px;
`;

export const Bottom = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 24px;

  div + div {
    margin-left: 18px;
  }
`;

export const Hint = styled.p`
  font-size: 0.875rem;
  color: var(--gray);
  margin-top: 12px;
  margin-bottom: 16px;
`;
